import { render, staticRenderFns } from "./ConsultaNotaFiscalDetalhes.vue?vue&type=template&id=fe8a8fe2"
import script from "./ConsultaNotaFiscalDetalhes.vue?vue&type=script&lang=js"
export * from "./ConsultaNotaFiscalDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports